import { render, staticRenderFns } from "./TabSplitSideBar.vue?vue&type=template&id=55666c6f&scoped=true"
import script from "./TabSplitSideBar.vue?vue&type=script&lang=js"
export * from "./TabSplitSideBar.vue?vue&type=script&lang=js"
import style0 from "./TabSplitSideBar.vue?vue&type=style&index=0&id=55666c6f&prod&scoped=true&lang=scss"
import style1 from "./TabSplitSideBar.vue?vue&type=style&index=1&id=55666c6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55666c6f",
  null
  
)

export default component.exports